import * as React from 'react';
import { Link } from "gatsby";
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import logoImage from '/src/images/logo/logo.svg';
import { MenuContext } from '../../../context/MenuContext';
import { TELEGRAM_KANAL, WHATSAPP_KANAL, INSTAGRAM_HESABI } from '../../../consts/Kanallar';
import "./footer.css";

const MAGAZALAR = [
    { ad: "Trendyol indirimleri", to: "/tdetails" },
    { ad: "Hepsiburada indirimleri", to: "/hdetails" },
    { ad: "Amazon indirimleri", to: "/adetails" },
    { ad: "MediaMarkt indirimleri", to: "/mmdetails" },
    { ad: "Vatan Bilgisayar indirimleri", to: "/vdetails" },
    { ad: "n11 indirimleri", to: "/ndetails" },
    { ad: "Pazarama indirimleri", to: "/pzdetails" },
    { ad: "İdefix indirimleri", to: "/ixdetails" },
];

const SECIMLER = [
    { ad: "Trendyol editör seçimleri", to: "/teddetails" },
    { ad: "Hepsiburada editör seçimleri", to: "/heddetails" },
    { ad: "Amazon editör seçimleri", to: "/aeddetails" },
];

/**
 * Site altı (onual.com referans alındı, kopya değil): kısa tanıtım + sosyal hesaplar, kategori / mağaza / editör
 * seçimi bağlantıları, yasal not ve #Ortaklık açıklaması. Eskisi koyu zeminli, sadece sosyal ikon + yasal metindi.
 */
export default function Footer() {
    const { pages } = React.useContext(MenuContext);
    return (
        <footer className="iu-alt">
            <div className="iu-alt-ic">
                <div className="iu-alt-ust">
                    <div className="iu-alt-tanitim">
                        <img src={logoImage} alt="İndirim Uzmanı" className="iu-alt-logo" />
                        <p>
                            İndirim Uzmanı; Trendyol, Hepsiburada ve Amazon'daki ürünlerin fiyatlarını sürekli takip eder, fiyat
                            geçmişine göre <b>gerçek indirimleri</b> yakalayıp paylaşır. Sahte indirimlere değil, gerçekten düşen
                            fiyatlara odaklan.
                        </p>
                        <div className="iu-alt-sosyal">
                            <a href={WHATSAPP_KANAL} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp kanalı"><WhatsAppIcon fontSize="small" /></a>
                            <a href={TELEGRAM_KANAL} target="_blank" rel="noopener noreferrer" aria-label="Telegram kanalı"><TelegramIcon fontSize="small" /></a>
                            <a href={INSTAGRAM_HESABI} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><InstagramIcon fontSize="small" /></a>
                        </div>
                    </div>
                    <div className="iu-alt-sutun">
                        <h3>Kategoriler</h3>
                        <div className="iu-alt-cipler">
                            {(pages || []).map((p) => <Link key={p.to} to={p.to}>{p.name}</Link>)}
                        </div>
                    </div>
                    <div className="iu-alt-sutun">
                        <h3>Mağazalar</h3>
                        <div className="iu-alt-cipler">
                            {MAGAZALAR.map((m) => <Link key={m.to} to={m.to}>{m.ad}</Link>)}
                        </div>
                    </div>
                    <div className="iu-alt-sutun">
                        <h3>Editörün seçimleri</h3>
                        <div className="iu-alt-cipler">
                            {SECIMLER.map((m) => <Link key={m.to} to={m.to}>{m.ad}</Link>)}
                        </div>
                    </div>
                </div>
                <div className="iu-alt-yasal">
                    <p>
                        İndirime giren ürünlerin fiyatları ve bulunabilirliği belirtildiği tarih/saat itibarıyla geçerlidir ve
                        değişebilir. Satın alınmak istenen ürünün, o esnada mağazada görüntülenen fiyat ve stok bilgisi geçerli olacaktır.
                    </p>
                    <p>
                        <b>#Ortaklık</b> · Sitedeki mağaza bağlantıları ortaklık bağlantısıdır; bu bağlantılardan yapılan alışverişlerden
                        komisyon kazanabiliriz, bu ödediğin fiyatı değiştirmez. Bir Amazon Ortağı olarak uygun alışverişlerden kazanç sağlıyoruz.
                    </p>
                    <p className="iu-alt-telif">© 2023 - {new Date().getFullYear()} indirimuzmani.com</p>
                </div>
            </div>
        </footer>
    );
}
